import { create } from "zustand";
import { ISocialLink } from "@/common/api/services/SocialLinksService/SocialLinksService";

interface ISocialLinksStore {
  links: Record<string, ISocialLink[]>;
  setLinks: (username: string, links: ISocialLink[]) => void;
}

export const useSocialLinksStore = create<ISocialLinksStore>((set) => ({
  links: {},
  setLinks: (username, links) => set((state) => ({ links: { ...state.links, [username]: links } })),
}));
